import { mapState } from 'pinia'

import { pinnedNames, togglePin } from 'src/components/navigation/feed_store.js'
import { routeTo } from 'src/components/navigation/navigation.js'
import OptionalRouterLink from 'src/components/optional_router_link/optional_router_link.vue'

import { useAnnouncementsStore } from 'src/stores/announcements.js'
import { useChatsStore } from 'src/stores/chats.js'
import { useDraftsStore } from 'src/stores/drafts.js'
import { useFollowRequestsStore } from 'src/stores/follow_requests.js'
import { useUsersStore } from 'src/stores/users.js'

const NavigationEntry = {
  // the attributes (a click) go to the entry's li
  inheritAttrs: false,
  // pinnable: a pin button (a feed in the desktop feed menu)
  props: ['item', 'pinnable'],
  components: {
    OptionalRouterLink,
  },
  methods: { togglePin },
  computed: {
    pinned() {
      return pinnedNames().includes(this.item.name)
    },
    routeTo() {
      return routeTo(this.item, this.currentUser)
    },
    badges() {
      return {
        drafts: this.draftsCount,
        unreadAnnouncements: this.unreadAnnouncementsCount,
        followRequests: this.followRequestsCount,
        unreadChats: this.unreadChatsCount,
      }
    },
    ...mapState(useAnnouncementsStore, ['unreadAnnouncementsCount']),
    ...mapState(useDraftsStore, ['draftsCount']),
    ...mapState(useUsersStore, ['currentUser']),
    ...mapState(useChatsStore, ['unreadChatsCount']),
    ...mapState(useFollowRequestsStore, ['followRequestsCount']),
  },
}

export default NavigationEntry
